import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LogoChangeService {
  private logoUrlSubject = new BehaviorSubject<string | null>(null);
  logoUrl$ = this.logoUrlSubject.asObservable();

  updateLogo(url: string) {
    this.logoUrlSubject.next(url);
  }
}